export enum DownloadStateEnum {
  IDLE,
  IN_PROGRESS,
  SUCCESS,
  ERROR,
}
